import { Button } from '@mui/material';
import { Box } from '@act/storybook';
import { useTracking } from '../tracking';

export interface StepActionsProps {
  activeStep: number;
  numberOfSteps: number;
  disableNext?: boolean;
  handleStep: (step: number) => void;
}

const StepActions = ({
  activeStep,
  disableNext = false,
  handleStep,
}: StepActionsProps) => {
  const tracking = useTracking();
  const { generateTrackingProps } = tracking || {};
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap="8px"
      padding="16px 0 8px"
    >
      <Button
        className="step-action-button"
        onClick={() => handleStep(activeStep - 1)}
        disabled={activeStep === 0}
        {...generateTrackingProps('previous-button')}
      >
        Previous
      </Button>
      <Button
        className="step-action-button"
        onClick={() => handleStep(activeStep + 1)}
        disabled={disableNext}
        variant="outlined"
        {...generateTrackingProps('next-button')}
      >
        Next
      </Button>
    </Box>
  );
};

export default StepActions;
